import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FilterTag from "../FilterTag";
import t from "@zendesk/client-i18n-tools";

export default class OriginFilter extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };

  render() {
    const { onClick, type, value } = this.props;

    return (
      <FilterTag
        type={type}
        onClick={onClick}
        value={t(`knowledge-verification.filters.${type}-${value}`)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/OriginFilter/index.js